// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
}

.modal-content {
  width: auto;
  border: 1px solid #707070;
  border-radius: 15px;
  padding: 40px 60px !important;
  text-align: center;
  opacity: 1;
}

.modal-content .security-icon {
  height: 60px;
  margin-bottom: 15px;
}

.otp-inputs {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.otp-inputs input {
  width: 50px !important;
  height: 45px;
  background-color: #f5f6ff;
  border-radius: 4px;
  border: none;
  padding: 20px;
  margin-right: 15px;
}

.modal-content h6 {
  color: #000000;
}

.modal-content p {
  font-size: 12px;
  color: #6e6e6e;
}

.modal-content .resend-otp {
  color: #3483f5;
  text-decoration: none;
  font-weight: 100;
  background-color: transparent;
  border: none;
}

.modal-content .btn {
  width: 260px;
}

.modal-content .resend {
  margin-top: 10px;
}

.btn-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal label {
  font-size: 12px;
}

.set-pin .form-group {
  text-align: start;
  width: 60%;
  margin-left: 65px;
}

.set-pin .form-control {
  background-color: #f5f6ff;
  border: none;
  margin-bottom: 10px;
  padding-left: 75px;
  letter-spacing: 10px;
  color: #000000;
  font-weight: 700;
  box-shadow: none;
}

.pin-modal .modal {
  position: relative;
}

.pin-modal .modal-content {
  justify-content: center;
  align-items: center;
}

.pin-modal .level {
  color: #000000;
}

.cancel-modal {
  background-color: #ffffff;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  position: absolute;
  z-index: 2;
  top: 16%;
  right: 31%;
  text-align: center;
  padding-top: 8px;
  cursor: pointer;
}

.pin-modal .form-group {
  text-align: start;
  margin-left: 0;
  width: 80%;
}

.modal .btn {
  background-color: #060d27 !important;
  border-radius: 30px !important;
}

.modal .btn:hover {
  color: #ffffff !important;
}

.pin-modal .form-control {
  background-color: #f5f6ff;
  border: none;
  margin-bottom: 16px;
  letter-spacing: 1px;
  color: #000000;
  width: 100%;
}

.modal-content .registration {
  border: none;
  background-color: transparent;
  color: #3482f3;
}

.modal-content .cancel-modal {
  position: absolute;
  font-weight: 600;
  right: 35px;
  top: 35px;
  cursor: pointer;
}

.modal-content small {
  color: crimson;
}

.trans-success .modal h4 {
  font-size: 16px;
}

.trans-success .modal-content {
  width: 30%;
  align-items: center;
}

.trans-success .modal img {
  height: 90px;
  width: 90px;
}

.trans-success .modal .token {
  color: #106745;
  font-size: 16px;
  font-weight: 600;
}

.trans-success .modal .amount {
  color: #060d27;
  font-size: 16px;
  font-weight: 600;
}

.trans-success .modal .desc {
  color: #000000;
}

.trans-success .modal .name {
  color: #6a6a6a;
}

.modal form .error {
  color: #de0000;
  font-size: 10px;
  text-align: center;
}

.modal .success-circle {
  background-color: #106745;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 6px solid #c4e6d9;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.modal .success-circle .fa-solid {
  font-size: 20px;
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/view/modal/Modal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.7);\n}\n\n.modal-content {\n  width: auto;\n  border: 1px solid #707070;\n  border-radius: 15px;\n  padding: 40px 60px !important;\n  text-align: center;\n  opacity: 1;\n}\n\n.modal-content .security-icon {\n  height: 60px;\n  margin-bottom: 15px;\n}\n\n.otp-inputs {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.otp-inputs input {\n  width: 50px !important;\n  height: 45px;\n  background-color: #f5f6ff;\n  border-radius: 4px;\n  border: none;\n  padding: 20px;\n  margin-right: 15px;\n}\n\n.modal-content h6 {\n  color: #000000;\n}\n\n.modal-content p {\n  font-size: 12px;\n  color: #6e6e6e;\n}\n\n.modal-content .resend-otp {\n  color: #3483f5;\n  text-decoration: none;\n  font-weight: 100;\n  background-color: transparent;\n  border: none;\n}\n\n.modal-content .btn {\n  width: 260px;\n}\n\n.modal-content .resend {\n  margin-top: 10px;\n}\n\n.btn-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal label {\n  font-size: 12px;\n}\n\n.set-pin .form-group {\n  text-align: start;\n  width: 60%;\n  margin-left: 65px;\n}\n\n.set-pin .form-control {\n  background-color: #f5f6ff;\n  border: none;\n  margin-bottom: 10px;\n  padding-left: 75px;\n  letter-spacing: 10px;\n  color: #000000;\n  font-weight: 700;\n  box-shadow: none;\n}\n\n.pin-modal .modal {\n  position: relative;\n}\n\n.pin-modal .modal-content {\n  justify-content: center;\n  align-items: center;\n}\n\n.pin-modal .level {\n  color: #000000;\n}\n\n.cancel-modal {\n  background-color: #ffffff;\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n  position: absolute;\n  z-index: 2;\n  top: 16%;\n  right: 31%;\n  text-align: center;\n  padding-top: 8px;\n  cursor: pointer;\n}\n\n.pin-modal .form-group {\n  text-align: start;\n  margin-left: 0;\n  width: 80%;\n}\n\n.modal .btn {\n  background-color: #060d27 !important;\n  border-radius: 30px !important;\n}\n\n.modal .btn:hover {\n  color: #ffffff !important;\n}\n\n.pin-modal .form-control {\n  background-color: #f5f6ff;\n  border: none;\n  margin-bottom: 16px;\n  letter-spacing: 1px;\n  color: #000000;\n  width: 100%;\n}\n\n.modal-content .registration {\n  border: none;\n  background-color: transparent;\n  color: #3482f3;\n}\n\n.modal-content .cancel-modal {\n  position: absolute;\n  font-weight: 600;\n  right: 35px;\n  top: 35px;\n  cursor: pointer;\n}\n\n.modal-content small {\n  color: crimson;\n}\n\n.trans-success .modal h4 {\n  font-size: 16px;\n}\n\n.trans-success .modal-content {\n  width: 30%;\n  align-items: center;\n}\n\n.trans-success .modal img {\n  height: 90px;\n  width: 90px;\n}\n\n.trans-success .modal .token {\n  color: #106745;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.trans-success .modal .amount {\n  color: #060d27;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.trans-success .modal .desc {\n  color: #000000;\n}\n\n.trans-success .modal .name {\n  color: #6a6a6a;\n}\n\n.modal form .error {\n  color: #de0000;\n  font-size: 10px;\n  text-align: center;\n}\n\n.modal .success-circle {\n  background-color: #106745;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: 6px solid #c4e6d9;\n  display: flex;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal .success-circle .fa-solid {\n  font-size: 20px;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
